import TemplateView from '../../TemplateView'
import _ from 'underscore'
import EditActionMenu from './EditActionMenu'

function EditActionButton({
    panelEl,
    headerEl,
    needMove,
    needCopy,
    needDelete,
    copyButtonMessageKey = "edit_panel.actions.copy",
    onDeleteCb = () => {},
    onMoveCb = () => {},
    onCopyCb = () => {},
})
{
    TemplateView.call(this);
    this.$panel = panelEl;
    this.$header = headerEl;
    this.needMove = needMove;
    this.needCopy = needCopy;
    this.needDelete = needDelete;

    this.copyButtonMessageKey = copyButtonMessageKey

    this.callbacks = {
        onDeleteCb,
        onMoveCb,
        onCopyCb,
    }
}

EditActionButton.prototype = _.create(TemplateView.prototype, {
    html: "<div class='actionButtonWrapper'>" +
          "  <div class='actionButton'>" +
          "    <div class='img'></div>" +
          "    <div class='action'><%=action%></div>" +
          "  </div>" +
          "</div>",

    updateOnInit: false,
    positionParams: {offset: "-1px -4px"},

    messageKeys: function()
    {
        return {
            action: "edit_panel.actions.title"
        }
    },

    afterRender: function()
    {
        this.menu = new EditActionMenu({
            buttonEl: this.find(".actionButton"),
            onDeleteCb: this.callbacks.onDeleteCb,
            onMoveCb: this.callbacks.onMoveCb,
            onCopyCb: this.callbacks.onCopyCb,
            copyButtonMessageKey: this.copyButtonMessageKey
        }).init(this.$panel);
        this.menu.setMove(this.needMove);
        this.menu.setCopy(this.needCopy);
        this.menu.setDelete(this.needDelete);
        this.menu.setEnableDeleteButton();
        this.menu.setEnableMoveButton()

        this.bindClick(() =>
                       {
                           this.$el.addClass('pressed');
                           this.menu.showAt(this.$el, this.$header, this.positionParams, _.bind(this._onSelect, this));
                       });
    },

    _onSelect: function()
    {
        this.hideMenu();
    },

    disableDeleteButton: function(text)
    {
        if (text)
            this.menu.setDisableDeleteButton(text);
        else
            this.menu.setEnableDeleteButton();
    },

    disableMoveButton: function(text) {
        if (text)
            this.menu.setDisableMoveButton(text)
        else
            this.menu.setEnableMoveButton()
    },

    hideMenu: function()
    {
        this.menu.hide();
    },

    hide: function()
    {
        TemplateView.prototype.hide.call(this);
        this.hideMenu();
    }
});

export default EditActionButton


// WEBPACK FOOTER //
// ./web/js/controls/task/EditActionButton.js